<template>
  <section v-if="spotCards.length" class="ni-section ni-spots" id="qingdao-world">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="t('newIndex.sections.spots.subtitle')"
        more-href="/active_list"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ t('newIndex.sections.spots.title') }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-spots__grid">
        <a
          v-for="(spot, index) in spotCards"
          :key="`spot-${index}`"
          :id="`spot-card-${index}`"
          class="ni-spots__card"
          :href="spot.href"
          :title="spot.title"
        >
          <div class="ni-spots__media">
            <img :src="spot.imageUrl" :alt="spot.title" />
          </div>

          <div class="ni-spots__footer">
            <p class="ni-spots__label">{{ getDisplayLabel(index, spot) }}</p>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import SectionHeader from './shared/SectionHeader.vue';

const props = defineProps({
  spotCards: {
    type: Array,
    default: () => [],
  },
});

const { t, tm } = useI18n();

function getDisplayLabel(index, spot) {
  if (spot.title) return spot.title;
  const labels = tm('newIndex.sections.spots.labels');
  if (Array.isArray(labels) && labels[index]) {
    return labels[index];
  }
  return '';
}
</script>

